module.exports = __webpack_public_path__ + "static/media/video-player-hover.6406d444.png";